<div class="container-fluid h-100 d-flex flex-column">
  <div class="d-flex justify-content-center align-items-center w-100 h-100">
    <img [src]="logo" />
  </div>
</div>
